import "mapbox-gl/dist/mapbox-gl.css";
import "./style.css";
import "./spinner.css";
import "./errors.css";
import "./mapbox-styles.css";

import { initializeMap } from "./js/mapbox.js";

document.addEventListener("DOMContentLoaded", () => {
  initializeMap().then();
});
